<!-- src/app/core/pwa/components/pwa-prompt/pwa-prompt.component.html -->

<div class="pwa-prompt-overlay" *ngIf="showPrompt" (click)="onDismiss()">
  <div class="pwa-prompt-card" (click)="$event.stopPropagation()">
    <!-- Botão de fechar -->
    <button class="close-button" (click)="onClose()" [disabled]="isInstalling">
      <ion-icon name="close"></ion-icon>
    </button>

    <!-- Ícone do app -->
    <div class="app-icon">
      <ion-icon name="phone-portrait-outline"></ion-icon>
    </div>

    <!-- Título -->
    <h2 class="prompt-title">Instalar Agrosystem APP</h2>

    <!-- Descrição -->
    <p class="prompt-description">
      Acesse rapidamente e trabalhe offline instalando nosso app!
    </p>

    <!-- Lista de benefícios -->
    <div class="benefits-list">
      <div class="benefit-item">
        <ion-icon name="flash-outline" class="benefit-icon"></ion-icon>
        <span>Acesso mais rápido</span>
      </div>
      <div class="benefit-item">
        <ion-icon name="cloud-offline-outline" class="benefit-icon"></ion-icon>
        <span>Funciona offline</span>
      </div>
      <div class="benefit-item">
        <ion-icon name="notifications-outline" class="benefit-icon"></ion-icon>
        <span>Notificações push</span>
      </div>
    </div>

    <!-- Botões de ação -->
    <div class="action-buttons">
      <ion-button
        fill="clear"
        color="medium"
        (click)="onDismiss()"
        [disabled]="isInstalling"
        class="dismiss-button">
        Agora não
      </ion-button>

      <ion-button
        fill="solid"
        color="primary"
        (click)="onInstall()"
        [disabled]="isInstalling"
        class="install-button">
        <ion-spinner *ngIf="isInstalling" name="crescent" class="button-spinner"></ion-spinner>
        <span *ngIf="!isInstalling">Instalar</span>
        <span *ngIf="isInstalling">Instalando...</span>
      </ion-button>
    </div>
  </div>
</div>
